module.exports = __webpack_public_path__ + "media/auto_data/check-on@3x-c1f390dd.svg";